import { baseService, GLOBAL_TAG_TYPES as TAG_TYPES } from '@repo/services';

export interface SendEmailRequest {
  to: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  template: string;
}

export interface SaveEmailTemplateRequest {
  name: string;
  subject: string;
  template: string;
  blob_ids?: string[];
}

const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const validateEmailList = (emailList: string[]) => {
  const invalidEmails = emailList.filter((email) => !isValidEmail(email));
  return invalidEmails.length === 0;
};

export const emailService = baseService.injectEndpoints({
  endpoints: (build) => ({
    sendEmail: build.mutation<any, SendEmailRequest>({
      query: (body) => {
        const { to, cc = [], bcc = [] } = body;

        if (!validateEmailList(to)) {
          throw new Error('Invalid "To" email addresses');
        }
        if (cc.length > 0 && !validateEmailList(cc)) {
          throw new Error('Invalid "Cc" email addresses');
        }
        if (bcc.length > 0 && !validateEmailList(bcc)) {
          throw new Error('Invalid "Bcc" email addresses');
        }

        return {
          url: '/v1/emails/send_email',
          method: 'POST',
          body,
        };
      },
      transformErrorResponse: (response: any) => response?.data?.error,
    }),
    saveEmailTemplate: build.mutation<any, SaveEmailTemplateRequest>({
      query: (body) => ({
        url: '/v1/email_templates',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (response: any) => response.data.message,
      invalidatesTags: [TAG_TYPES.emailTempalte],
    }),
    uploadImage: build.mutation<any, FormData>({
      query: (formData) => ({
        url: '/v1/assets/upload',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const {
  useSendEmailMutation,
  useSaveEmailTemplateMutation,
  useUploadImageMutation,
} = emailService;

export default emailService;
